/**
 * Reducer to hold the list of current responses added by the user
 */

import _ from 'lodash';
import {
  ADD_CHAT_ASSESSMENT_RESPONSE,
  REMOVE_CHAT_ASSESSMENT_RESPONSE
} from '../actions/types';

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_CHAT_ASSESSMENT_RESPONSE:
      return {
        ...state,
        [action.questionId]: {
          response: action.response,
          score: action.score
        }
      };
    case REMOVE_CHAT_ASSESSMENT_RESPONSE: {
      return _.omit(state, [action.questionId]);
    }
    default:
      return state;
  }
};
